import React from "react";
import "../Css/Test.css";
import worldcom_pic from "../images/worldcom_pic.svg";

function mysql_database() {
  return (
    <div className="sepNav">
      <div className="row1">
        <div>
          <h5 className="titleh1">How to connect MYSQL to node.js?</h5>
          <img src={worldcom_pic} alt="worldcom_pic" />

          <div className="row1">
            <div className="row1">
              <div
                className="history col-xs-10 col-sm-8 col-md-10"
                style={{ paddingBottom: "100px" }}
              >
                <h1 className="H1_a">How to connect MYSQL to node.js?</h1>
                <p className="text-justify">
                  <strong>Summary:</strong> in this article, you will learn how
                  to connect to the MySQL database server from a node.js
                </p>
                <p className="text-justify">
                  Download and install the latest version of node.js on your
                  system.
                  <br />
                  You can download the latest version of node.js{" "}
                  <a href="https://nodejs.org/en/">Here</a>
                </p>

                <h2>
                  First: Create a folder using <code>mkdir</code> command, in
                  your GitBash,
                  <br />
                  after creating the folder you need to create a package.json
                  file in your folder
                </h2>
                <p>
                  Use<code> npm init</code> to create a package
                </p>

                <h2>
                  Second, install node.js for MySQL package by using the
                  following command:{" "}
                </h2>
                <code>npm install mysql</code>
                <p>
                  Third, create the <code> connect.js </code> inside of the
                  folder that you created for storing the code that connects to
                  the MySQL database server.
                  <br />
                  to create a database in you're MySQL WorkBench, <br /> <br />{" "}
                  first open mysql and then click on the connection folder, by
                  default mysql already has a connection folder called root.
                  when you opened, <br /> then on thr top left, there is an icon
                  if you hover over that icon it says create a new Schema, click
                  there and give a name to you're database,
                  <br />
                  <br />
                  Or just run this command,
                  <code>CREATE DATABASE "your database name" </code>
                  <br />
                  Once the database is created, you are ready to connect to it
                  from the Node.js application. We will use the MySQL WorkBench
                  database for connection, therefore, you should create the
                  database in your MySQL database server by running the
                  following CREATE DATABASE statement in :
                  <br />
                  <br />
                  Once the database is created, you are ready to connect to it
                  from the Node.js application.
                </p>

                <h2>Connecting to MySQL database server from node.js</h2>
                <p>
                  First, import the mysql module by using the following
                  statement:{" "}
                </p>

                <code>let mysql = require('mysql');</code>
                <br />
                <p>
                  Second, create a connection to the MySQL database by calling
                  the createConnection() method and providing the detailed
                  information on MySQL server such as host, user, password and
                  database as follows:
                  <pre>
                    <code className="hljs-keyword">
                      let connection = mysql.createConnection
                    </code>
                  </pre>
                </p>
                <p className="text-justify">
                  Discription <br />
                </p>

                <hr
                  style={{
                    paddingTop: "1px",
                    borderTop: "1px solid black",
                  }}
                ></hr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default mysql_database;
